import { Viewer } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import { formatDateTime } from '../../../../utils/helpers/formatDate';
import { useEffect, useRef } from 'react';
interface ViewerBoxProps {
  imgSrc: string;
  name: string;
  date: Date;
  initialValue: string;
  style?: object;
  isActive?: boolean;
}

export const ViewerBox = ({
  imgSrc,
  name,
  date,
  initialValue,
  style,
  isActive = true
}: ViewerBoxProps) => {
  const viewerRef = useRef<Viewer>(null);

  useEffect(() => {
    if (viewerRef.current) {
      console.log(viewerRef.current, 'viewerRef');
      viewerRef.current.getInstance().setMarkdown(initialValue);
    }
  }, [initialValue]);
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...style
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: 8,
            alignItems: 'center'
          }}
        >
          <img width={24} height={24} src={imgSrc} />
          <span style={{ fontWeight: 500, fontSize: 12 }}>
            {name}{' '}
            {/* {!isActive && (
              <span style={{ color: '#D98282', marginLeft: 4 }}>
                대화가 종료되었습니다.
              </span>
            )} */}
          </span>
        </div>
        <span style={{ fontSize: 9, fontWeight: 500, color: '#656565' }}>
          {formatDateTime(date)}
        </span>
      </div>
      <div style={{ marginTop: 8 }}>
        <Viewer ref={viewerRef} theme="white" initialValue={initialValue} />
      </div>
    </>
  );
};
